import { isArray } from 'util';
import { mapCollection, sortByNumber } from '../../utils/collection.utils';
import { SaleOrderLineComplement } from '../sale-order-line-complement';
import { parseNumber } from '../../utils/number.utils';

export class SaleOrderLineComplementBuilder {

  static fromJson(json): SaleOrderLineComplement {
    return (json) ? new SaleOrderLineComplement(
      json.hash,
      json.complementHash,
      json.complementName,
      json.complementCode,
      json.complementDescription,
      json.complementNeedSerialNumber,
      json.complementWeight,
      parseNumber(json.amount),
      parseNumber(json.totalAmount)
    ) : null;
  }

  static fromJsonList(list): SaleOrderLineComplement[] {
    return (isArray(list)) ? sortByNumber('amount', mapCollection(SaleOrderLineComplementBuilder.fromJson, list)) : [];
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-line-complement-builder.ts